import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table,
} from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import ReportActions from '@Actions/reportActions';
import H3Text from '@Uilib/h3Text';
import H3DateSelector from '@Uilib/h3DateSelector';
import './style.scss';
import { QUANTITY } from '@Apis/constants';
import Helpers from '@Apis/helpers';

/**
 * @param status
 */
class VendorPurchaseLedger extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      selectedInterval: 'this_month',
      startDateMomentEpoch: dayjs().startOf('month').valueOf(),
      endDateMomentEpoch: dayjs().endOf('month').valueOf(),
      purchaseLedgerColumns: [
        {
          title: 'DATE',
          fixed: 'left',
          render: (record) => <H3Text text={record?.grn_date ? record?.grn_date : ''} className="prod-table__text" />,
        },
        {
          title: 'PRODUCT NAME',
          width: '250px',
          render: (record) => <H3Text text={record?.product_sku_name} className="prod-table__text" />,
        },
        {
          title: 'TAX',
          render: (record) => <H3Text text={`${record?.tax_value}%`} className="prod-table__text" />,
        },
        {
          title: 'PO NUMBER',
          render: (record) => <H3Text text={record?.po_number || '-'} className="prod-table__text" />,
        },
        {
          title: 'GRN NUMBER',
          render: (record) => <H3Text text={record?.grn_number} className="prod-table__text" />,
        },
        {
          title: 'VENDOR INVOICE#',
          render: (record) => <H3Text text={record?.invoice_number || '-'} className="prod-table__text" />,
        },
        {
          title: 'QUANTITY',
          render: (record) => (
            <Fragment>
              <div>
                <div>
                  {`Order - ${QUANTITY(record?.po_quantity, Number(record?.precision))} ${record?.uqc?.toProperCase() || ''}`}
                </div>
                <div>
                  {`Received - ${QUANTITY(record?.grn_quantity, Number(record?.precision))} ${record?.uqc?.toProperCase() || ''}`}
                </div>
                <div>
                  {`Returned - ${QUANTITY(record?.returned_quantity, Number(record?.precision))} ${record?.uqc?.toProperCase() || ''}`}
                </div>
              </div>
            </Fragment>
          ),
        },
        {
          title: 'PO UNIT PRICE',
          render: (record) => (
            <div>
              {this.props.MONEY(record?.po_unit_price || '')}
              <H3Text text={`${this.props.MONEY(record?.po_unit_price * (1 + (record?.tax_value / 100)))} incl. ${record?.tax_value}% Tax`} className="table-subscript" />
            </div>
          ),
        },
        {
          title: 'GRN UNIT PRICE',
          render: (record) => (
            <div>
              {this.props.MONEY(record?.grn_unit_price || '')}
              <H3Text text={`${this.props.MONEY(record?.grn_unit_price * (1 + (record?.tax_value / 100)))} incl. ${record?.tax_value}% Tax`} className="table-subscript" />
            </div>
          ),
        },
        {
          title: 'GRN LINE TOTAL',
          render: (record) => this.props.MONEY(record?.grn_line_total || '0'),
        },
      ],
      page: 1,
      limit: 10,
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      const { isUserReady } = state;
      const { getReports, user, selectedSeller } = props;
      if (user?.tenant_info?.org_id && selectedSeller?.tenant_seller_id && !isUserReady) {
        getReports('purchase_ledger', '', user?.tenant_info?.org_id, user?.tenant_info?.tenant_id, dayjs().startOf('month').valueOf(), dayjs().endOf('month').valueOf(), 'purchase_ledger', 1, 30, '', selectedSeller?.seller_id);
        return {
          ...state,
          isUserReady: true,
        };
      }
    }
    return state;
  }

  /**
   *
   * @param {*} startDateMomentEpoch
   * @param {*} endDateMomentEpoch
   */
  downloadReportData() {
    const {
      purchaseLedger,
    } = this.props;
    const { fileBase64 } = purchaseLedger;
    Helpers.downloadFileFromBase64(fileBase64, 'purchase_ledger.xlsx');
  }

  /**
   *
   * @param {*} status
   * @return
   */
  render() {
    const {
      purchaseLedger, getReportsLoading, getReports, selectedSeller, user,
    } = this.props;
    const {
      purchaseLedgerColumns, startDateMomentEpoch, endDateMomentEpoch, selectedInterval, page, limit,
    } = this.state;
    return (
      <Fragment>
        <div className="vendor-pos__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-24 ant-col-xs-24">
              <div className="generic-table-container">
                <Table
                  title={() => (
                    <div className="purchase-ledger__table-header">
                      <div className="purchase-ledger__table-header__left">
                        {`${purchaseLedger?.purchase_ledger?.length || '0'} Goods Received`}
                      </div>
                      <div className="purchase-ledger__table-header__right">
                        {purchaseLedger?.purchase_ledger?.length > 0 && (
                          <div className="report-header__action-btn" onClick={() => this.downloadReportData()}>
                            <H3Text
                              text={(
                                <div>
                                  <DownloadOutlined />
                                </div>
                              )}
                              className="action-button"
                            />
                          </div>
                        )}
                        <div className="">
                          <H3DateSelector
                            selectedInterval={selectedInterval}
                            onListChange={(value) => this.handleDataChange(value)}
                            startDate={startDateMomentEpoch}
                            endDate={endDateMomentEpoch}
                            onDateChange={(date) => {
                              this.setState({
                                startDateMomentEpoch: dayjs(date[0])?.valueOf(),
                                endDateMomentEpoch: dayjs(date[1])?.valueOf(),
                                selectedInterval: 'customize',
                              });
                              getReports('purchase_ledger', '', user?.tenant_info?.org_id, user?.tenant_info?.tenant_id, dayjs(date[0])?.valueOf(), dayjs(date[1])?.valueOf(), 'purchase_ledger', 1, 30, '', selectedSeller?.seller_id);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  loading={getReportsLoading}
                  showHeader
                  size="small"
                  scroll={{ x: 'max-content' }}
                  columns={purchaseLedgerColumns}
                  rowKey="po_id"
                  dataSource={purchaseLedger && purchaseLedger.purchase_ledger ? purchaseLedger.purchase_ledger : []}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, ReportReducers, SellerReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  purchaseLedger: ReportReducers.purchaseLedger,
  getReportsLoading: ReportReducers.getReportsLoading,
  getDownloadReportsLoading: ReportReducers.getDownloadReportsLoading,
  selectedSeller: SellerReducers.selectedSeller,
});

const mapDispatchToProps = (dispatch) => ({
  getReports: (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, reportType, page, limit, departmentId, sellerId) => dispatch(ReportActions.getReports(firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, reportType, page, limit, departmentId, sellerId)),
  getDownloadReports: (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId) => dispatch(ReportActions.getDownloadReports(firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId)),
});

VendorPurchaseLedger.propTypes = {
  user: PropTypes.any,
  MONEY: PropTypes.func,
  getDownloadReports: PropTypes.func,
  getReports: PropTypes.func,
  getReportsLoading: PropTypes.bool,
  purchaseLedger: PropTypes.any,
  selectedSeller: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VendorPurchaseLedger));
